import { c as _c } from "react/compiler-runtime";
import type { FC } from "react";
import styled from "styled-components";
import { PlateLeaf, type PlateLeafProps } from "@platejs/core/react";
export const CodeLeaf: FC<PlateLeafProps> = t0 => {
  const $ = _c(7);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      whiteSpace: "pre-wrap",
      borderRadius: "0.375rem",
      padding: "0.2em 0.3em",
      fontFamily: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace",
      fontSize: "0.875rem",
      lineHeight: "1.25rem"
    };
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== children || $[5] !== props) {
    t2 = <Code as="code" style={t1} {...props}>{children}</Code>;
    $[4] = children;
    $[5] = props;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
const Code = styled(PlateLeaf)`
	background-color: rgba(135, 131, 120, 0.15);
	border-radius: 3px;
	font-size: 85%;
	font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo,
		Courier, monospace;
	line-height: normal;
	padding: 0.2em 0.4em;
	white-space: pre-wrap;
`;